import { useEffect, useState } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import { useTranslation } from 'react-i18next';
import Checkbox from '@components/shared/forms/RawCheckbox';
import actions from '@store/actions/listingSearchPage';
import { LeaseTypes, ListingSearchFilterTypes } from '@root/types';
import { useDispatch } from 'react-redux';
import useHighlightedClick from '../useHighlightedClick';
import s from '../Filters.module.less';

const leaseTypes: Array<{ label: string; value: LeaseTypes; translationKey: string }> = [
  {
    label: 'Direct',
    value: 'direct',
    translationKey: 'filters:leaseType:direct',
  },
  {
    label: 'flex',
    value: 'flex',
    translationKey: 'filters:leaseType:flex',
  },
  {
    label: 'sublease',
    value: 'sublease',
    translationKey: 'filters:leaseType:sublease',
  },
];

type Props = {
  criteria: ListingSearchCriteria;
  onChange: (criteria: ListingSearchCriteria) => void;
  type: ListingSearchFilterTypes;
};

const LeaseTypeFilter = ({ criteria, onChange, type }: Props) => {
  const [selectedLeaseTypes, setSelectedLeaseTypes] = useState(criteria.leaseTypes());
  useEffect(() => {
    setSelectedLeaseTypes(criteria.leaseTypes());
  }, [criteria]);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setHighlighted, isHighlighted } = useHighlightedClick();
  const changeLeaseType = (leaseType: LeaseTypes) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const nowChecked = e.target.checked;
    setHighlighted(leaseType);

    if (nowChecked) {
      setSelectedLeaseTypes([...selectedLeaseTypes, leaseType]);
      criteria.addValue('leaseTypes', leaseType);
    } else {
      setSelectedLeaseTypes(
        selectedLeaseTypes.filter(changedLeaseType => changedLeaseType !== leaseType),
      );
      criteria.removeValue('leaseTypes', leaseType);
    }
    dispatch(actions.leaseTypeFilterChanged(criteria.leaseTypes()));
    onChange(criteria);
  };

  return (
    <ul className={s.filterList}>
      {leaseTypes.map(({ label, value, translationKey }) => (
        <li key={label} className={classnames(isHighlighted(value) && s.highlighted)}>
          <Checkbox
            checked={selectedLeaseTypes.includes(value)}
            name={`${label}-${type}`}
            className={s.checkbox}
            onChange={changeLeaseType(value)}
          >
            {t(translationKey)}
          </Checkbox>
        </li>
      ))}
    </ul>
  );
};

export default LeaseTypeFilter;
